export enum FeaturePermissionsEnum {
  AniaNatEventsIndex = "RMA_RISK_INDEX_ITA_ANIA_CURCL_NATEVE",
  AniaNonCatIndex = "RMA_RISK_INDEX_ITA_ANIA_CURCL_NNATCA",
  CysItaNatEventsIndex = "CYS_RISK_INDEX_ITA_EURAIN_CURCL_NATEVE",
  CysItaNonCatIndex = "CYS_RISK_INDEX_ITA_EURAIN_CURCL_NNATCA",

  CysRiskAssessmentPdf = "CYS_FEAT_BUTN_POLICYRISKPDF",
  CysFeatExtendedClaimsVal = "CYS_FEAT_INFO_EXTCLAIMSVAL",
  // TODO: geocoder should work based on this permissions and geocoderSearchItalyOnly (permissions have higher priority)
  // https://cystellar.atlassian.net/browse/REALERISK-1395
  CysGeocoderSearchItalyOnly = "CYS_FEAT_GEOC_ITAONLY",
  CysGeocoderSearchWorldOnly = "CYS_FEAT_GEOC_WRLONLY",
}
